import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ConfirmProvider } from "./components/ui/ConfirmDialog";
import { ToastProvider } from "./components/ui/Toast";
import { TooltipProvider } from "./components/ui/Tooltip";
import "react-day-picker/style.css";
import "./index.css";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: { refetchOnWindowFocus: false, staleTime: 30 * 1000 },
	},
});

const container = document.getElementById("root");
if (!container) throw new Error("Root element is missing");

createRoot(container).render(
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<TooltipProvider>
				<ToastProvider>
					<ConfirmProvider>
						<BrowserRouter>
							<App />
						</BrowserRouter>
					</ConfirmProvider>
				</ToastProvider>
			</TooltipProvider>
		</QueryClientProvider>
	</StrictMode>,
);
